import React from "react";
import "../../App.css";
import { Typography } from "@mui/material";
import { colors } from "../../config/colors";
import { SideBarAddLogo, DownloadTempLogo } from "../../assets/icons";
import {
  CustomDropdown,
  SearchDropdown,
  TextInput,
  Chips,
  PrimaryButton,
  SecondaryButton,
  CustomRadioButton,
  ModalPopUp,
  UploadErrorMsg,
  CustomModal,
} from "../../components";
import { ApiService } from "../../utils/ApiService";
import { API_URL, ADMIN_TYPE, NOTIFICATION_ENUM } from "../../utils/Constants";
import { Form } from "react-bootstrap";
import NotificationStimulator from "./NotificationStimulator";
import {
  MAX_WIDTH,
  TEXT_ALIGN_CENTER,
  TEXT_ALIGN_LEFT,
  TEXT_ALIGN_RIGHT,
} from "../../config/styles";

const NOTI_TYPE = {
  SCHOOL: "SCHOOL",
  STUDENT: "STUDENT",
  BULK: "BULK",
};
const STEP_STATE = { active: 0, disabled: 1, completed: 3 };

const SUBJECT_MAX_LEN = 200;
const MESSAGE_MAX_LEN = 924;

class NotificationCreate extends React.Component {
  constructor(props) {
    super(props);
    this.adminRole = localStorage.getItem("role");
    this.merchantId = localStorage.getItem("globalMerchantId");
    this.schoolName = localStorage.getItem("superAdminSchoolName");
    if (this.adminRole == ADMIN_TYPE.SCHOOLADMIN) {
      this.merchantId = localStorage.getItem("schoolAdminMerchantId");
      this.schoolName = localStorage.getItem("schoolAdminSchoolName");
    }
    this.firstName = localStorage.getItem("firstName");
    this.lastName = localStorage.getItem("lastName");
    this.sentNotiSuccessMsg =
      "Notification broadcast has started, users will recieve your notification in some time";
    this.state = {
      isNetworking: false,
      snackMsg: this.sentNotiSuccessMsg,
      showSnack: false,
      notiType: NOTI_TYPE.SCHOOL,
      gradesDivisionList: [],
      gradeSelected: "",
      gradeList: [],
      divisionSelected: "",
      divisionList: [],
      recipients: [],
      gradeDivisionMapList: [],
      isSchoolCustom: true,
      subject: this.schoolName.substring(0, 200),
      message: "",
      studentId: "",
      studentList: [],
      newLogin: true,
      isNewLoginDelete: true,
      isSalesAdmin: false,
      isUpdateRadioActive: true,
      showValidationDownloadBtn: false,
      showAlertModal: false,
      alertModalMsg: "",
      processValidationFileName: "",
      uplodedFileName: "",
      fieldVal: "",
      file1: "",
      uploadFailure1: false,
      showUploadGrid: false,
      uploadDataList: [],
      spinner: false,
      commitList: false,
      exsistingList: [],
      fileSizeData: "",
      commitShow: false,
      currentStatus: null,
      showIsProgressMsg: false,
      step1State: STEP_STATE.active,
      isUploadBtnDisable: true,
      isUploadBtnLoading: false,
      step1Toggle: true,
      step2State: STEP_STATE.disabled,
      isValidateBtnDisable: false,
      isValidateBtnLoading: false,
      step2Toggle: true,
      step3State: STEP_STATE.disabled,
      isSubmitBtnLoading: false,
      step3Toggle: true,
      progressPercent: 0,
      progressCompleteText: "",
      progressFileDownloadUrl: "",
      validateProgressPercent: 0,
      errorMsg: "",
      sentBulk2: false,
      showErrorLog: false,
    };
  }

  componentDidMount() {
    this.onFetchGradeDivision();
  }

  getErrorMessage = (response) => {
    return response.status.message === "INVLD_UPLD_FILE_CNT_TYPE"
      ? "Please upload valid file"
      : response.status.errorCode === "PROCESS_NO_DATA"
        ? response.status.message
        : response.status.errorCode === "EXCEEDS MAX RECORDS LIMIT"
          ? response.status.internalMessage
          : "Some issue occurred. Please try again.";
  }

  handleErrorMessage = (response) => {
    response.status.errorCode === "PROCESS_NO_DATA"
      ? this.setState({ showErrorLog: false })
      : response.status.errorCode === "EXCEEDS MAX RECORDS LIMIT"
        ? this.setState({ showErrorLog: false })
        : this.setState({ showErrorLog: true });
  }

  onFetchGradeDivision = async () => {
    try {
      const url = API_URL.GET_GRADE_DIVISON + "/" + this.merchantId;
      const resp = await ApiService.getRequest(url);
      if (resp.status && resp.status.code === "Y") {
        const grades = resp.body.map((item) => item.grade);
        this.setState({ gradesDivisionList: resp.body, gradeList: grades });
      }
    } catch (err) {
      console.error("Error fetching grade and division data:", err);
    }
  };

  onFetchStudentId = async () => {
    try {
      if (this.state.studentId.length === 0) return;
      const url =
        API_URL.GET_STUDENT_IDS +
        "/" +
        this.merchantId +
        "?studentId=" +
        this.state.studentId;
      const resp = await ApiService.getRequest(url);
      if (resp.status && resp.status.code === "Y") {
        this.setState({ studentList: resp.body });
      }
    } catch (err) {
      console.error("Error fetching student IDs:", err);
    }
  };

  onToggleNotificationType = (type) => {
    this.setState({
      notiType: type,
      recipients: [],
      gradeDivisionMapList: [],
      gradeSelected: "",
      divisionSelected: "",
      divisionList: [],
      studentId: "",
      studentList: [],
      isSchoolCustom: true,
      uplodedFileName: "",
      errorMsg: "",
      showErrorLog: false,
      isUploadBtnDisable: true,
      step1State: STEP_STATE.active,
    });
  };

  onToggleSchoolLevel = (isSchoolCustom) => {
    this.setState({
      gradeDivisionMapList: [],
      gradeSelected: "",
      divisionSelected: "",
      divisionList: [],
      isSchoolCustom: isSchoolCustom,
      recipients: isSchoolCustom ? [] : ["All School"],
    });
  };

  onGradeSelected = (key) => {
    let index = key || 0;
    const selectedItem = this.state.gradesDivisionList[index];
    this.setState({
      gradeSelected: selectedItem.grade,
      divisionList: selectedItem.divisions,
    });
  };

  onDivisionSelected = (key) => {
    let index = key || 0;
    this.setState({ divisionSelected: this.state.divisionList[index] });
  };

  onAddRecipient = () => {
    let recipient = this.state.gradeSelected;
    let mapObj = { strGrade: this.state.gradeSelected };
    if (this.state.divisionSelected) {
      recipient = recipient + ", " + this.state.divisionSelected;
      mapObj = {
        strGrade: this.state.gradeSelected,
        strDivision: this.state.divisionSelected,
      };
    }
    if (this.state.recipients.indexOf(recipient) != -1) return;
    this.setState({
      recipients: [...this.state.recipients, recipient],
      gradeDivisionMapList: [...this.state.gradeDivisionMapList, mapObj],
      gradeSelected: "",
      divisionSelected: "",
      divisionList: [],
    });
  };

  onAddStudentId = (value) => {
    if (this.state.recipients.indexOf(value) != -1) return;
    this.setState({ recipients: [...this.state.recipients, value] });
  };

  onRemoveRecipient = (label, index) => {
    const newRecipient = this.state.recipients;
    newRecipient.splice(index, 1);
    let newGradeDivMapList = this.state.gradeDivisionMapList;
    if (this.state.notiType === NOTI_TYPE.SCHOOL && this.state.isSchoolCustom) {
      newGradeDivMapList.splice(index, 1);
    }
    this.setState({
      recipients: newRecipient,
      gradeDivisionMapList: newGradeDivMapList,
    });
  };

  onSubjectChange = (event) => {
    this.setState({ subject: event.target.value });
  };

  onMessageChange = (event) => {
    this.setState({ message: event.target.value });
  };

  onSendNotification = async () => {
    try {
      let categoryEnum = NOTIFICATION_ENUM.SCHOOL_BROADCAST;
      if (this.state.notiType === NOTI_TYPE.STUDENT)
        categoryEnum = NOTIFICATION_ENUM.STUDENT;
      if (this.state.notiType === NOTI_TYPE.SCHOOL && this.state.isSchoolCustom)
        categoryEnum = NOTIFICATION_ENUM.SCHOOL_CUSTOM;

      let recipientConstruct = {};
      if (this.state.notiType === NOTI_TYPE.SCHOOL)
        recipientConstruct = {
          gradeDivisionMapList: this.state.gradeDivisionMapList,
        };
      if (this.state.notiType === NOTI_TYPE.STUDENT)
        recipientConstruct = {
          studentMcBeneficiaryIdList: this.state.recipients,
        };
      const payload = {
        createdBy: this.firstName + " " + this.lastName,
        merchantId: this.merchantId,
        merchantName: this.schoolName,
        status: "INITIATED",
        strSubject: this.state.subject,
        strMessage: this.state.message,
        notificationCategoryEnum: categoryEnum,
        pushNotificationConstructRecipients: { ...recipientConstruct },
      };
      this.setState({ isNetworking: true });
      const resp = await ApiService.postRequest(
        API_URL.PUSH_NOTIFICATION,
        payload
      );
      if (resp.status && resp.status.code === "Y") {
        this.setState(
          {
            showSnack: true,
            snackMsg: this.sentNotiSuccessMsg,
            isNetworking: false,
          },
          this.onReset
        );
      } else {
        this.setState({
          isNetworking: false,
          snackMsg: resp.status.message,
          showSnack: true,
        });
      }
    } catch (err) {
      console.error("Error sending notification:", err);
      this.setState({ isNetworking: false });
    }
  };

  onSendBulkNotification = async () => {
    this.setState({
      isUploadBtnDisable: true,
      uplodedFileName: "",
      errorMsg: "",
      showErrorLog: false,
      step1State: STEP_STATE.active,
    });
    try {
      let categoryEnum = NOTIFICATION_ENUM.BULK;
      if (this.state.notiType === NOTI_TYPE.BULK)
        categoryEnum = NOTIFICATION_ENUM.BULK;
      if (this.state.notiType === NOTI_TYPE.SCHOOL && this.state.isSchoolCustom)
        categoryEnum = NOTIFICATION_ENUM.BULK;

      let recipientConstruct = {};
      if (this.state.notiType === NOTI_TYPE.BULK)
        recipientConstruct = {
          gradeDivisionMapList: this.state.gradeDivisionMapList,
        };
      if (this.state.notiType === NOTI_TYPE.BULK)
        recipientConstruct = {
          studentMcBeneficiaryIdList: this.state.recipients,
        };
      const payload = {
        createdBy: this.firstName + " " + this.lastName,
        merchantId: this.merchantId,
        merchantName: this.schoolName,
        status: "INITIATED",
        strSubject: this.state.subject,
        strMessage: this.state.message,
        notificationCategoryEnum: categoryEnum,
        pushNotificationConstructRecipients: { ...recipientConstruct },
      };
      this.setState({ isNetworking: true });
      const resp = await ApiService.postRequest(
        API_URL.PUSH_NOTIFICATION,
        payload
      );

      if (resp.status && resp.status.code === "Y") {
        this.setState(
          {
            showSnack: true,
            snackMsg: this.sentNotiSuccessMsg,
            isNetworking: false,
          },
          this.onReset
        );
      } else {
        this.setState({
          isNetworking: false,
          snackMsg: resp.status.message,
          showSnack: true,
        });
      }
    } catch (err) {
      console.error("Error sending bulk notification:", err);
      this.setState({ isNetworking: false });
    }
  };

  onReset = () => {
    let resetRecipient = [];
    if (this.state.notiType === NOTI_TYPE.SCHOOL && !this.state.isSchoolCustom)
      resetRecipient = ["All School"];
    this.setState({
      gradeDivisionMapList: [],
      gradeSelected: "",
      divisionSelected: "",
      divisionList: [],
      message: "",
      studentId: "",
      studentList: [],
      recipients: resetRecipient,
    });
  };

  onCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({ showSnack: false });
  };
  handleDownloadTemplate = (type = "DOWNLOAD") => {
    let authCode = localStorage.getItem("bearer");
    let roleData = localStorage.getItem("role");
    let merchantIdGlobal = "";
    if (roleData == "SUPERADMIN") {
      merchantIdGlobal = localStorage.getItem("globalMerchantId");
    }
    if (roleData == "SCHOOLADMIN") {
      merchantIdGlobal = localStorage.getItem("schoolAdminMerchantId");
    }
    const typeUrl = API_URL.DOWNLOAD_USER_TEMPLATE;
    const url = typeUrl + "?schoolId=" + merchantIdGlobal;
    fetch(url, {
      method: "POST",
      headers: {
        Authorization: authCode,
        "X-Auth-Token": "otk_ODMwYmI5OTUtNTg0Ni00NTMxLWE3YTMtZTE2ZWNmOWIxNmJh",
        Accept: "application/json",
      },
    })
      .then((response) => {
        const auth = response.headers.get("Authorization");
        if (auth) localStorage.setItem("bearer", auth);
        return response.blob();
      })
      .then((blob) => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = "Template.xlsx";
        document.body.appendChild(a);
        a.click();
        a.remove();
      })
      .catch((err) => alert(err));
  };

  renderSelectType() {
    const selectTypeList = [
      {
        header: "School notification",
        description: "Will be send to the entire school base",
        fieldName: NOTI_TYPE.SCHOOL,
      },
      {
        header: "Student notification",
        description: "Will be sent to selective students / parents",
        fieldName: NOTI_TYPE.STUDENT,
      },
      {
        header: "Bulk notification",
        description: "Upload templates to initiate push notifications",
        fieldName: NOTI_TYPE.BULK,
      },
    ];
    return (
      <div className="view-report-container w-100">
        <Typography
          variant="h5"
          sx={{
            color: colors.custom,
            marginBottom: 3,
            textAlign: TEXT_ALIGN_LEFT,
          }}
        >
          Select Notification Type
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: colors.custom,
            marginBottom: 3,
            textAlign: TEXT_ALIGN_LEFT,
          }}
        >
          Please select the notification type to send App notification
        </Typography>
        <div className="d-flex flex-column gap-2 w-100">
          {selectTypeList.map((item) => (
            <CustomRadioButton
              key={item.header}
              label={
                <div className="d-flex flex-column gap-1 w-100">
                  <Typography variant="subtitle2" className="left-aligned">
                    {item.header}
                  </Typography>
                  <Typography variant="h4" className="left-aligned">
                    {item.description}
                  </Typography>
                </div>
              }
              disabled={this.adminRole == ADMIN_TYPE.SALESADMIN}
              isChecked={this.state.notiType === item.fieldName}
              onClick={() => this.onToggleNotificationType(item.fieldName)}
            />
          ))}
        </div>
      </div>
    );
  }

  renderSchoolSelector() {
    return this.state.notiType === NOTI_TYPE.SCHOOL ? (
      <div className="d-flex flex-column gap-2 w-100">
        <CustomRadioButton
          label={
            <Typography variant="subtitle2" className="left-aligned">
              Grades & Divisions
            </Typography>
          }
          disabled={this.adminRole == ADMIN_TYPE.SALESADMIN}
          isChecked={this.state.isSchoolCustom}
          onClick={() => this.onToggleSchoolLevel(true)}
        />
        <CustomRadioButton
          label={
            <Typography variant="subtitle2" className="left-aligned">
              All School
            </Typography>
          }
          disabled={this.adminRole == ADMIN_TYPE.SALESADMIN}
          isChecked={!this.state.isSchoolCustom}
          onClick={() => this.onToggleSchoolLevel(false)}
        />
      </div>
    ) : null;
  }

  renderSearchBox() {
    if (this.state.notiType === NOTI_TYPE.STUDENT) {
      return (
        <div className="my-3 w-100">
          <SearchDropdown
            label="Student ID"
            value={this.state.studentId}
            width={MAX_WIDTH}
            disabled={this.state.recipients.length >= 20}
            items={this.state.studentList}
            onSelect={this.onAddStudentId}
            onChange={(event) =>
              this.setState(
                { studentId: event.target.value },
                this.onFetchStudentId
              )
            }
          />
        </div>
      );
    }
    return null;
  }

  renderGradeSelector() {
    if (this.state.notiType === NOTI_TYPE.SCHOOL && this.state.isSchoolCustom) {
      return (
        <div className="d-flex flex-row gap-2 my-3 align-items-center">
          <CustomDropdown
            label="Grade"
            value={this.state.gradeSelected}
            disabled={
              this.adminRole == ADMIN_TYPE.SALESADMIN ||
              this.state.gradeList.length === 0
            }
            width={185}
            items={this.state.gradeList}
            onChange={this.onGradeSelected}
          />

          <CustomDropdown
            label="Division"
            disabled={
              this.adminRole == ADMIN_TYPE.SALESADMIN ||
              this.state.divisionList.length === 0
            }
            value={this.state.divisionSelected}
            width={185}
            items={this.state.divisionList}
            onChange={this.onDivisionSelected}
          />

          <SecondaryButton
            label="Add"
            onClick={this.onAddRecipient}
            disabled={!this.state.gradeSelected}
          />
        </div>
      );
    }
    return null;
  }

  renderRecipientList() {
    return (
      <div className="receipent-list">
        {this.state.recipients.length === 0 ? (
          <Typography
            component="label"
            variant="subtitle2"
            sx={{
              textAlign: TEXT_ALIGN_CENTER,
              width: MAX_WIDTH,
              color: colors.grayLight,
            }}
          >
            Recipient List
          </Typography>
        ) : (
          <div className="d-flex flex-wrap">
            {this.state.recipients.map((recipt, indx) => (
              <div style={{ marginRight: 16, marginBottom: 16 }} key={recipt}>
                <Chips
                  index={indx}
                  label={recipt}
                  onClose={
                    this.state.isSchoolCustom ? this.onRemoveRecipient : null
                  }
                />
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }

  renderAddRecipients() {
    let selectDesc = "";
    if (this.state.notiType === NOTI_TYPE.SCHOOL)
      selectDesc = "Please add the recipient details";
    if (this.state.notiType === NOTI_TYPE.STUDENT)
      selectDesc = "Please add the recipient details by selecting student ID's";

    return (
      <div className="view-report-container w-100 pb-4">
        <Typography
          variant="h5"
          sx={{
            color: colors.custom,
            marginBottom: 3,
            textAlign: TEXT_ALIGN_LEFT,
          }}
        >
          Add recipients
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: colors.custom,
            marginBottom: 3,
            textAlign: TEXT_ALIGN_LEFT,
          }}
        >
          {selectDesc}
        </Typography>
        {this.renderSchoolSelector()}
        {this.renderGradeSelector()}
        {this.renderSearchBox()}
        {this.renderRecipientList()}
        {this.state.notiType === NOTI_TYPE.STUDENT && (
          <Typography
            variant="h4"
            sx={{ color: colors.nonActive, marginLeft: 2, marginTop: 1 }}
          >
            Maximum 20 recipients allowed
          </Typography>
        )}
        {this.state.notiType === NOTI_TYPE.STUDENT &&
          !this.state.isSchoolCustom && (
            <Typography
              variant="h4"
              sx={{ color: colors.nonActive, marginLeft: 2, marginTop: 1 }}
            >
              All registered students of this school will recieve this
              notification
            </Typography>
          )}
      </div>
    );
  }

  downloadRecipients() {
    return (
      <div className="view-report-container w-100 pb-4">
        <div className="d-flex flex-column gap-2 w-100 pb-2">
          <div>
            <Typography variant="body1" sx={{ textAlign: TEXT_ALIGN_LEFT }}>
              1. Download the bulk add recipient template
            </Typography>

            <button
              className="download-box"
              onClick={this.handleDownloadTemplate}
            >
              <DownloadTempLogo bgColor={colors.primary} />
              <Typography
                variant="body1"
                sx={{ textAlign: TEXT_ALIGN_LEFT, marginLeft: 2 }}
              >
                Template.xls
              </Typography>
            </button>
          </div>
          <div>
            <Typography variant="body1" sx={{ textAlign: TEXT_ALIGN_LEFT }}>
              2. Upload the filled template to add reciepents in bulk
            </Typography>

            <div className="download-box">
              <SideBarAddLogo bgColor={colors.primary} />
              <Typography
                variant="body1"
                sx={{ textAlign: TEXT_ALIGN_LEFT, marginLeft: 2 }}
              >
                <Form.Control
                  type="file"
                  id="custom-file"
                  label={this.state.uplodedFileName || "Upload template file"}
                  accept=".xls,.xlsx"
                  onChange={this.fileChange}
                  disabled={
                    this.state.isSalesAdmin || this.state.isSubmitBtnLoading
                  }
                  custom
                />
              </Typography>
            </div>
            <div style={{ marginLeft: 20, marginTop: 8 }}>
              <PrimaryButton
                label="Upload"
                onClick={this.fileUpload}
                disabled={
                  this.state.step1State === STEP_STATE.completed ||
                  this.state.isUploadBtnDisable
                }
                isLoading={this.state.isUploadBtnLoading}
              />
            </div>
          </div>
          {this.state.showIsProgressMsg && (
            <UploadErrorMsg msg="Another upload is in progress. Database update cannot be performed at this moment. Please try after sometime." />
          )}
        </div>
      </div>
    );
  }
  fileChange = (e) => {
    this.onChange(e.target.files);
    this.setState({
      showUploadGrid: false,

      step1State: STEP_STATE.active,
      isUploadBtnDisable: false,
      isUploadBtnLoading: false,
      step1Toggle: true,

      step2State: STEP_STATE.disabled,
      isValidateBtnDisable: false,
      isValidateBtnLoading: false,
      step2Toggle: true,

      step3State: STEP_STATE.disabled,
      isSubmitBtnLoading: false,
      step3Toggle: true,
    });
  };

  fileUpload = () => {
    if (
      this.state.fileSizeData <= 1000000 &&
      this.state.uplodedFileName != ""
    ) {
      let merchantIdGlobal = "";
      let roleData = localStorage.getItem("role");
      if (roleData == "SUPERADMIN") {
        merchantIdGlobal = localStorage.getItem("globalMerchantId");
      }
      if (roleData == "SCHOOLADMIN") {
        merchantIdGlobal = localStorage.getItem("schoolAdminMerchantId");
      }
      // const file = this.state.file;
      this.setState({ isUploadBtnLoading: true });
      const inputFiles = document.querySelectorAll('input[type="file"]');
      const formData = new FormData();

      for (const file of inputFiles) {
        formData.append("file", file.files[0]);
        formData.append("schoolId", merchantIdGlobal);
      }

      let authCode = localStorage.getItem("bearer");
      fetch(API_URL.UPLOAD_STUDENT_TEMPLATE, {
        method: "POST",
        body: formData,
        headers: {
          Authorization: authCode,
          "X-Auth-Token":
            "otk_ODMwYmI5OTUtNTg0Ni00NTMxLWE3YTMtZTE2ZWNmOWIxNmJh",
          Accept: "application/json",
        },
      })
        .then((response) => {
          const auth = response.headers.get("Authorization");
          if (auth) localStorage.setItem("bearer", auth);
          return response.json();
        })
        .then((response) => {
          if (
            (response.error != undefined &&
              response.error.status_code === 401) ||
            response.status === "403" ||
            (response.status.internalMessage != null &&
              response.status.internalMessage.includes("403"))
          ) {
            this.setState({
              showAlertModal: true,
              alertModalMsg: this.alertMsg.sessionExpiry,
              sentBulk2: false,
            });
            return;
          }
          this.setState({ isUploadBtnLoading: false, fieldVal: response.body });
          if (response.status.code == "Y") {
            this.setState({
              step1State: STEP_STATE.completed,
              isUploadBtnDisable: true,
              sentBulk2: true,
            });
            setTimeout(() => {
              this.setState({
                step1Toggle: false,
                step2State: STEP_STATE.active,
              });
            }, 2000);
          } else if (response.status.code == "N") {
            const errMsg = this.getErrorMessage(response)
            this.handleErrorMessage(response);
            this.setState({
              showAlertModal: false,
              alertModalMsg: errMsg,
              errorMsg: errMsg,
              sentBulk2: false,
            });
          }
        }).catch((err) => {
          this.setState({
            isUploadBtnLoading: false,
            showAlertModal: true,
            alertModalMsg: "Some issue occurred. Please try again.",
            sentBulk2: false,
          });
          console.error("Error uploading file:", err);
        });
    } else if (this.state.fileSizeData >= 1000000) {
      this.setState({
        showAlertModal: true,
        alertModalMsg: this.alertMsg.fileSizeMsg,
        sentBulk2: false,
        uplodedFileName: ''
      });
    } else if (this.state.fileSizeData === "") {
      this.setState({
        showAlertModal: true,
        alertModalMsg: this.alertMsg.noFileErr,
        sentBulk2: false,
      });
    }
  };

  onChange = (e) => {
    let sizeOfFile = e;
    if (!sizeOfFile[0]) return;
    let fileName = sizeOfFile[0].name;
    if (fileName.length > 25) {
      fileName = fileName.slice(0, 22);
      fileName = fileName + "...";
    }
    this.setState({
      uplodedFileName: fileName,
      fileSizeData: sizeOfFile[0].size,
    });
    if (sizeOfFile[0].size > 1000000) {
      this.setState({
        showAlertModal: true,
        alertModalMsg: this.alertMsg.fileSizeMsg,
      });
    }
  };

  renderErrorMsg(msg) {
    return (
      <div className="d-flex align-items-center p-3">
        <div className="errorMsgIcon" />
        <Typography variant="h4" sx={{ color: "#f15b60" }}>
          {msg}
        </Typography>
      </div>
    );
  }

  renerComposeMsg() {
    const isMsgError = this.state.message.length > MESSAGE_MAX_LEN;
    return (
      <div className="d-flex flex-column p-3 w-100 gap-3">
        <TextInput
          id="message"
          label="Subject"
          disabled
          style={{ width: "100%" }}
          value={this.state.subject}
          onChange={this.onSubjectChange}
        />

        <TextInput
          multiline
          id="message"
          label="Message"
          rows={10}
          disabled={this.adminRole == ADMIN_TYPE.SALESADMIN}
          style={{ width: "100%" }}
          error={isMsgError}
          value={this.state.message}
          onChange={this.onMessageChange}
        />
        <Typography
          variant="h4"
          sx={{
            color: colors.grayLight,
            marginTop: "-36px",
            textAlign: TEXT_ALIGN_RIGHT,
            paddingRight: 1,
          }}
        >
          {this.state.message.length}/{MESSAGE_MAX_LEN}
        </Typography>
        {isMsgError &&
          this.renderErrorMsg("Please limit your characters to 924")}
      </div>
    );
  }

  renderAlertModal() {
    return (
      <ModalPopUp
        isVisible={this.state.showAlertModal}
        title="Information"
        bodyMsg={this.state.alertModalMsg}
        onHide={this.onHideAlertModal}
      />
    );
  }
  onHideAlertModal = () => {
    if (this.state.step3State === STEP_STATE.completed) this.resetStates();
    this.setState({ showAlertModal: false, alertModalMsg: "" });
  };

  renderButtons() {
    let isSendDisabled = true;
    let isResetDisabled = true;
    let sentBulk = true;
    if (
      this.state.recipients.length > 0 &&
      this.state.subject.length > 0 &&
      this.state.subject.length <= SUBJECT_MAX_LEN &&
      this.state.message.length > 0 &&
      this.state.message.length <= MESSAGE_MAX_LEN
    )
      isSendDisabled = false;
    if (this.state.recipients.length > 0 || this.state.message.length > 0)
      isResetDisabled = false;
    if (this.state.message.length > 0 && this.state.sentBulk2) sentBulk = false;
    return (
      <div className="d-flex m-3 flex-row justify-content-between gap-3">
        <PrimaryButton
          label="Send"
          disabled={
            this.state.notiType === NOTI_TYPE.BULK
              ? sentBulk
              : isSendDisabled || this.adminRole == ADMIN_TYPE.SALESADMIN
          }
          onClick={
            this.state.notiType === NOTI_TYPE.BULK
              ? this.onSendBulkNotification
              : this.onSendNotification
          }
          isLoading={this.state.isNetworking}
        />

        <SecondaryButton
          label="Reset"
          disabled={
            this.adminRole == ADMIN_TYPE.SALESADMIN ||
            isResetDisabled ||
            this.state.isNetworking
          }
          onClick={this.onReset}
        />
      </div>
    );
  }

  render() {
    return (
      <div>
        <div className="d-flex flex-row w-100">
          <div
            className="d-flex flex-column p-4 gap-3"
            style={{ width: "65%", minWidth: 520 }}
          >
            {this.renderSelectType()}
            {this.state.notiType === NOTI_TYPE.BULK
              ? this.downloadRecipients()
              : this.renderAddRecipients()}
            {this.renerComposeMsg()}
            {this.renderButtons()}
            {this.renderAlertModal()}
          </div>
          <NotificationStimulator message={this.state.message} />
        </div>

        <CustomModal
          show={this.state.showSnack}
          title={"Message has been sent successfully"}
          message={this.state.snackMsg}
          onHide={this.onCloseSnack}
        />
      </div>
    );
  }
}

export default NotificationCreate;
